import { LinkedinSmall as m } from "./linkedin-small.js";
import { FacebookSmall as r } from "./facebook-small.js";
import { TwitterSmall as o } from "./twitter-small.js";
import { AdyenA as t } from "./adyen-a.js";
import { AdyenAFilled as l } from "./adyen-a-filled.js";
import { Instagram2Small as i } from "./instagram-2-small.js";
import { InstagramSmall as a } from "./instagram-small.js";
import { Twitter2Small as p } from "./twitter-2-small.js";
const g = {
  LinkedinSmall: m,
  FacebookSmall: r,
  TwitterSmall: o,
  AdyenA: t,
  AdyenAFilled: l,
  Instagram2Small: i,
  InstagramSmall: a,
  Twitter2Small: p
};
export {
  g as Extra24
};
